import { motion } from "framer-motion";
import DonateButton from "@/components/DonateButton";
import { SCENES } from "@/lib/images";

export default function DonateCTA() {
  return (
    <section className="relative grain overflow-hidden py-24 md:py-32">
      <div className="absolute inset-0">
        <img src={SCENES.candles} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/60 to-black/70" />
      </div>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.8 }}
        className="relative mx-auto max-w-3xl px-5 text-center text-cream"
      >
        <p className="font-hand text-3xl text-gold">Help us light the candles</p>
        <h2 className="mt-2 font-serif text-4xl font-bold tracking-tight md:text-6xl">A Call to Celebrate</h2>
        <p className="mx-auto mt-6 max-w-xl leading-relaxed text-cream/85 md:text-lg">
          Through your kindness, we create a celebration worthy of a century — one that spans
          generations and invites every soul to share in the beauty of Agnes's story.
        </p>
        <div className="mt-9 flex justify-center">
          <DonateButton size="lg" testid="cta-donate-button" />
        </div>
      </motion.div>
    </section>
  );
}
